import { useMutation } from "@tanstack/react-query";
import { joinWaitlist } from "@/adapters/api";

export function useJoinWaitlist() {
	return useMutation({ mutationFn: joinWaitlist });
}
